/* Precision 3D — site interactions (no dependencies) */
(function () {
  'use strict';
  var doc = document.documentElement;
  doc.classList.add('pd-js');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-pd-reveal], [data-pd-reveal-group], .pd-process');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Mobile action bar: appears after the first screen ---------- */
  function initMobileBar() {
    var bar = document.querySelector('.pd-mbar');
    if (!bar) return;
    document.body.classList.add('pd-has-mbar');
    var shown = false;
    function onScroll() {
      var show = window.scrollY > window.innerHeight * 0.6;
      if (show !== shown) { shown = show; bar.classList.toggle('is-shown', show); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

   /* ---------- Services sub-nav: highlight current service ---------- */
  function initServiceNav() {
    var nav = document.querySelector('.pd-svc-nav');
    if (!nav) return;
    var header = document.querySelector('.section-header');
    if (header) nav.style.setProperty('--pd-sticky-top', '0px');
    var links = {};
    nav.querySelectorAll('a[href^="#"]').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var ids = Object.keys(links).filter(function (id) { return document.getElementById(id); });
    var current = null, ticking = false;
    function setActive(id) {
      if (!id || id === current) return;
      current = id;
      ids.forEach(function (k) { links[k].classList.toggle('is-active', k === id); });
      var ul = links[id].closest('ul');
      if (ul) ul.scrollTo({ left: links[id].offsetLeft - 16, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function update() {
      ticking = false;
      // The active service is the last one whose top has passed just below the sticky menu
      var line = nav.getBoundingClientRect().bottom + 40;
      var pick = ids[0];
      ids.forEach(function (id) { if (document.getElementById(id).getBoundingClientRect().top <= line) pick = id; });
      setActive(pick);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Portfolio: filters + detail modal ---------- */
  function initWork() {
    document.querySelectorAll('[data-pd-work]').forEach(function (root) {
      var cards = Array.prototype.slice.call(root.querySelectorAll('.pd-proj'));
      var filters = root.querySelectorAll('.pd-filter');
      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var cat = btn.getAttribute('data-filter');
          filters.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          cards.forEach(function (c) {
            c.hidden = !(cat === 'all' || c.getAttribute('data-cat') === cat);
          });
        });
      });

      var modal = root.querySelector('.pd-modal');
      if (!modal || typeof modal.showModal !== 'function') return;
      var mImg = modal.querySelector('[data-m-img]');
      var mTitle = modal.querySelector('[data-m-title]');
      var mFacts = modal.querySelector('[data-m-facts]');
      var mCat = modal.querySelector('[data-m-cat]');
      var lastFocus = null;
      cards.forEach(function (card) {
        if (card.tagName !== 'BUTTON') return;
        card.addEventListener('click', function () {
          var tpl = card.querySelector('template');
          lastFocus = card;
          var img = card.querySelector('.pd-proj__img img');
          mImg.innerHTML = '';
          if (img) {
            var big = img.cloneNode();
            big.removeAttribute('srcset');
            big.src = img.getAttribute('data-full') || img.src;
            big.loading = 'eager';
            mImg.appendChild(big);
          }
          mTitle.textContent = card.querySelector('h3').textContent;
          mCat.textContent = card.getAttribute('data-cat-label') || '';
          mFacts.innerHTML = tpl ? tpl.innerHTML : '';
          modal.showModal();
        });
      });
      function close() { modal.close(); }
      modal.querySelector('.pd-modal__close').addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      modal.addEventListener('close', function () { if (lastFocus) lastFocus.focus(); });
    });
  }

  /* ---------- Instant-quote hand-off ----------
     A file dropped/chosen on any .pd-drop (e.g. the homepage) is kept in
     IndexedDB, the visitor is taken to the quote page, and the file is fed
     straight into the quote tool there — no second upload needed. */
  var DB = 'pd-handoff', STORE = 'files';
  function idb() {
    return new Promise(function (res, rej) {
      if (!window.indexedDB) return rej(new Error('no-idb'));
      var r = indexedDB.open(DB, 1);
      r.onupgradeneeded = function () { r.result.createObjectStore(STORE); };
      r.onsuccess = function () { res(r.result); };
      r.onerror = function () { rej(r.error); };
    });
  }
  function putFiles(files) {
    return idb().then(function (db) {
      return new Promise(function (res, rej) {
        var tx = db.transaction(STORE, 'readwrite');
        tx.objectStore(STORE).put({ t: Date.now(), files: files }, 'pending');
        tx.oncomplete = function () { res(); };
        tx.onerror = function () { rej(tx.error); };
      });
    });
  }
  function takeFiles() {
    return idb().then(function (db) {
      return new Promise(function (res) {
        var tx = db.transaction(STORE, 'readwrite');
        var st = tx.objectStore(STORE);
        var g = st.get('pending');
        g.onsuccess = function () {
          var v = g.result;
          st.delete('pending');
          // only accept a hand-off from the last 10 minutes
          res(v && Date.now() - v.t < 10 * 60 * 1000 ? v.files : null);
        };
        g.onerror = function () { res(null); };
      });
    }).catch(function () { return null; });
  }
  var OK_EXT = /\.(stl|step|stp|3mf)$/i;

  function initDropHandoff() {
    document.querySelectorAll('.pd-drop').forEach(function (zone) {
      var href = zone.getAttribute('data-href') || '/pages/instant-quote';
      var input = zone.querySelector('input[type=file]');
      var status = zone.querySelector('.pd-drop__status');
      function go(fileList) {
        var files = Array.prototype.filter.call(fileList || [], function (f) { return OK_EXT.test(f.name); });
        if (!files.length) {
          if (status) status.textContent = 'Please choose an STL, STEP or 3MF file.';
          return;
        }
        if (status) status.textContent = 'Opening your quote…';
        putFiles(files).then(
          function () { window.location.href = href + (href.indexOf('?') > -1 ? '&' : '?') + 'handoff=1'; },
          function () { window.location.href = href; }
        );
      }
      zone.addEventListener('click', function (e) {
        if (e.target === input) return;
        e.preventDefault();
        if (input) input.click(); else window.location.href = href;
      });
      zone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (input) input.click(); }
      });
      if (input) input.addEventListener('change', function () { go(input.files); });
      ['dragenter', 'dragover'].forEach(function (ev) {
        zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('is-over'); });
      });
      ['dragleave', 'dragend'].forEach(function (ev) {
        zone.addEventListener(ev, function () { zone.classList.remove('is-over'); });
      });
      zone.addEventListener('drop', function (e) {
        e.preventDefault();
        zone.classList.remove('is-over');
        go(e.dataTransfer && e.dataTransfer.files);
      });
    });
  }

  function receiveHandoff() {
    var input = document.querySelector('.p3d-quote-file-input');
    if (!input || location.search.indexOf('handoff=1') === -1) return;
    takeFiles().then(function (files) {
      if (!files || !files.length || typeof DataTransfer === 'undefined') return;
      var tries = 0;
      (function feed() {
        // wait until the quote tool's libraries are ready
        if (!(window.THREE && THREE.STLLoader) && tries++ < 50) return setTimeout(feed, 100);
        try {
          var dt = new DataTransfer();
          files.forEach(function (f) { dt.items.add(f instanceof File ? f : new File([f], f.name || 'model.stl')); });
          input.files = dt.files;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          var tool = document.querySelector('.p3d-quote-wrapper');
          if (tool && tool.scrollIntoView) tool.scrollIntoView({ block: 'start' });
        } catch (e) { /* visitor can still upload manually */ }
        if (history.replaceState) history.replaceState(null, '', location.pathname);
      })();
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    initReveal();
    initMobileBar();
    initServiceNav();
    initWork();
    initDropHandoff();
  });
  window.addEventListener('load', receiveHandoff);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initWork();
    initDropHandoff();
  });
})();
